"use client";

import React from "react";

import { createSVGIcon } from "./util";

/**
 * @trackcomponent
 */
export const LightBulbOn = createSVGIcon(
  <>
    <path
      d="M7.99674 16H12.8452L14.9181 11.19C14.9721 11.0646 15 10.9296 15 10.7931V10.5791C15 8.05011 12.9499 6 10.4209 6C7.89201 6 5.8419 8.05011 5.8419 10.5791V10.7931C5.8419 10.9296 5.86976 11.0646 5.92377 11.19L7.99674 16Z"
      stroke="currentColor"
    />
    <path d="M8 18H13" strokeLinecap="round" stroke="currentColor" />
    <path d="M9 20L12 20" strokeLinecap="round" stroke="currentColor" />
    <path d="M10 3V1" strokeLinecap="round" stroke="currentColor" />
    <path d="M3 8L1 7" strokeLinecap="round" stroke="currentColor" />
    <path d="M18 8L20 7" strokeLinecap="round" stroke="currentColor" />
  </>,
  "LightBulb",
  {
    viewBox: "0 0 21 21",
    titleAccess: "LightBulb",
    fill: "none",
  }
);
